module.exports = __webpack_public_path__ + "33c0f20a79057e68e971c32e2a1b9b96.svg";